import {Card,} from '../types';
import {PlatformPropertyCard} from '@flexinet/ui-components';


export const Profile = ({record}: { record: Card }) => {
    console.debug(record)

    const properties = [
        {
            label: 'ID',
            value: record.id as string,
            span: 6,
        }, {
            label: 'Customer',
            value: record.customerId,
            span: 6,
        }, {
            label: 'Name',
            value: record.name,
            span: 6,
        },
        {
            label: 'Created',
            value: record.created as string,
            formatAs: 'Timestamp',
            span: 3,
        },
        {
            label: 'Last Updated',
            value: record.updated as string,
            formatAs: 'Timestamp',
            span: 3,
        }];


    return (
        <PlatformPropertyCard properties={properties}/>
    );


};
